function createOptionChilds(arr) {
  if (!Array.isArray(arr)) {
    return arr;
  }
  return arr.map(createOptionChild);
}

function createOptionChild([name, id]) {
  return {
    name,
    id,
  };
}

export function createOption(
  key,
  title,
  titleDesc,
  type,
  childs,
  hasValue = false,
  openUpdate = true
) {
  if (!titleDesc) titleDesc = title;
  return {
    key,
    title,
    titleDesc,
    type,
    childs: createOptionChilds(childs),
    hasValue,
    openUpdate,
  };
}

export function addChilds(options, index, childs) {
  childs.forEach(item => {
    options[index].childs.push(createOptionChild(item));
  });
}
